import { dayStart } from '../format';
import type { SimStatus, SimStep } from './api';

export const STEPS: SimStep[] = ['5m', '15m', '1h', 'event'];
/** Play: one step every this long, while the last one has finished */
export const PLAY_EVERY_MS = 1500;

/** How far the virtual clock is through the replayed range, 0..1 */
export function progressOf(status: Pick<SimStatus, 'from' | 'to' | 'clock'>): number {
  const from = new Date(status.from).getTime();
  const span = new Date(status.to).getTime() - from;
  if (!(span > 0)) return 0;
  return Math.min(1, Math.max(0, (new Date(status.clock).getTime() - from) / span));
}

/** 'YYYY-MM-DD' in the browser's zone: from its midnight to the next one, as ISO */
export const dayRange = (day: string): { from: string; to: string } => ({ from: dayStart(day), to: dayStart(day, 1) });

/** Next (and Play) can run only when the session is ready: not finished, and no step running here or elsewhere (a reload, a second tab) */
export const canStep = (status: SimStatus | null, busy: boolean): boolean => status !== null && !busy && status.state === 'ready';
